import { Component, Input } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { CommonModule, NgClass } from '@angular/common';

@Component({
  selector: 'ra-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLinkWithHref, NgClass],
})
export class TitleComponent {
  @Input() removePaddings: boolean = false;
}
